import React from 'react';

const BookProgress = () => (
  <div className="book-progress">
    <p className="current-chapter">CURRENT CHAPTER</p>
    <p className="progress-chapter">Introduction</p>
    <button type="button" className="update-progress Rectangle-2">UPDATE PROGRESS</button>
  </div>
);

export default BookProgress;
